import React, { useState } from "react";
import { useSelector } from 'react-redux';
import { useTranslation } from "react-i18next";

import {
  Input,
  Button
} from '@lockerpm/design';

import {
  CloseOutlined
} from "@ant-design/icons";

import global from "../../../../../config/global";

const FamilyMembers = (props) => {
  const { t } = useTranslation();
  const {
    className = '',
    familyMembers = [],
    setFamilyMembers = () => { },
  } = props;

  const userInfo = useSelector(state => state.auth.userInfo)

  const [emailInput, setEmailInput] = useState('')

  const removeMember = (email) => {
    setFamilyMembers(familyMembers.filter(e => e !== email))
  }

  const addMember = () => {
    let values = []
    if (emailInput.includes('/')) {
      values = emailInput.split('/')
    } else if (emailInput.includes(' ')) {
      values = emailInput.split(' ')
    } else if (emailInput.includes(',')) {
      values = emailInput.split(',')
    } else {
      values = [emailInput]
    }
    values = values.filter(Boolean).filter((v) => global.patterns.EMAIL.test(v) && !familyMembers.includes(v));
    values = [...new Set(values)];
    if ([...familyMembers, ...values].length > 6) {
      global.pushError({
        message: t('notification.error.payment')
      })
    } else {
      setEmailInput('');
      setFamilyMembers([...familyMembers, ...values]);
    }
  }

  return (
    <div className={className}>
      <h3 className="font-semibold text-[18px] mb-2">
        {t('manage_plans.payment_step.family.invite_member')}
      </h3>
      <p className="mb-3">
        {t('manage_plans.payment_step.family.invite_member_desc')}
      </p>
      <div className="flex items-center">
        <Input
          value={emailInput}
          className="mr-3"
          placeholder={t(`placeholder.email`)}
          onChange={(e) => setEmailInput(e.target.value)}
          onPressEnter={() => addMember()}
        />
        <Button
          type="primary"
          onClick={addMember}
        >
          {t('button.add')}
        </Button>
      </div>

      <p className="mt-3 mb-6">
        {t('manage_plans.payment_step.family.invite_member_desc_2')}
      </p>

      <p className="font-semibold text-[18px] mb-3">
        {t('manage_plans.payment_step.family.list_member') }
      </p>

      <p className="py-1">
        {userInfo.email}
      </p>
      {
        familyMembers.map((email, index) => <div
          key="index"
          className="flex justify-between py-1"
        >
          <p>
            {email}
          </p>
          <Button
            danger
            type="text"
            size="small"
            icon={<CloseOutlined />}
            onClick={() => removeMember(email)}
          />
        </div>)
      }
    </div>
  );
}

export default FamilyMembers;